import {odxIconSets} from "../constants";
import React, {useEffect, useRef} from "react";
import OdxIcon from "./Odx-Icon";

// TODO callbacks für Suche implementieren

interface OdxSearchbarProps extends React.HTMLProps<HTMLInputElement> {
    onSearch: (searchTerm: string) => void;
    id: string
}

const OdxSearchbar: React.FC<OdxSearchbarProps> = ({onSearch, id}) => {
    const containerRef = useRef<HTMLDivElement>(null);


    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSearch(event.target.value);
    };

    useEffect(() => {
        if (containerRef.current) {
            const elements = containerRef.current.querySelectorAll("[data-odx-search-bar-control]");
            elements.forEach((element) => {
                const dataOdxSearchbar = element.getAttribute("data-odx-search-bar-control");
                if (dataOdxSearchbar) {
                    element.setAttribute("odxsearchbarcontrol", "");
                    element.removeAttribute("data-odx-search-bar-control");
                }
            });
        }
    }, []);

    return (
        <div className="odx-search-bar" ref={containerRef}>
            <div className="odx-search-bar__prefix">
                <OdxIcon name="search" iconSet={odxIconSets.core} size={"md"}/>
            </div>
            <input id={"OdxSearchBarInput_" + id} placeholder="Search" onChange={handleInputChange} type="search"
                   className="odx-search-bar__input" data-odx-search-bar-control/>
        </div>
    );
};

export default OdxSearchbar;